var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-snackbar',{attrs:{"md-position":"center","md-duration":2500,"md-active":_vm.showSnackbar},on:{"update:mdActive":function($event){_vm.showSnackbar=$event},"update:md-active":function($event){_vm.showSnackbar=$event}}},[_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }